module.exports = __webpack_public_path__ + "static/media/ninx8.1cea04c6.jpg";